import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapProjectsRevenueCorrelation = {
  show: async(props) => {
    const { default: RevenueCorrelation } = await import('@/vue_widgets/mlap/revenue_correlation/index.vue')
    createVueApp(RevenueCorrelation, { props })
  }
}
